import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type DropdownMenuRadioGroupProps = RadixDropdownMenu.DropdownMenuRadioGroupProps;

export const DropdownMenuRadioGroup = memo(({ className, ...restOfProps }: DropdownMenuRadioGroupProps) => {
  return <RadixDropdownMenu.RadioGroup className={cn('flex flex-col gap-2', className)} {...restOfProps} />;
});

DropdownMenuRadioGroup.displayName = 'DropdownMenuRadioGroup';
